import { render } from "./GifTboxtwothree.vue?vue&type=template&id=3fedde26"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/GifTboxtwothree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fedde26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fedde26', __exports__)) {
    api.reload('3fedde26', __exports__)
  }
  
  module.hot.accept("./GifTboxtwothree.vue?vue&type=template&id=3fedde26", () => {
    api.rerender('3fedde26', render)
  })

}


export default __exports__